import axios from "axios";
import apiConfig from "../../config/api-config";
import config from "../../config/local-config";

const trackMyOrder = (email, orderId, breakSetKit = null, breakReturns = null, captcha = null) => {
  const version = "v1";
  const serviceName = "accounts/track-order-details";
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/?`;
  const domain = "carparts.com";
  const opt = "orderStatus";

  let enableSetKit = config.orderDetailsBreakSetKit || 0;
  let enableReturnRequests = config.orderDetailsBreakReturnRequests || 0;

  if (breakSetKit !== null) {
    enableSetKit = breakSetKit ? 1 : 0;
  }

  if (breakReturns !== null) {
    enableReturnRequests = breakReturns ? 1 : 0;
  }

  let body = {
    domain: domain,
    opt: opt,
    orderId: orderId,
    emailAdd: email,
    apikey: apiConfig.apiKey,
    brsetkit: enableSetKit,
    brreturns: enableReturnRequests,
    'g-recaptcha-response': captcha,
  };

  return axios.get(apiUrl, { params: body });
};
export default trackMyOrder;
